import React, { useState } from 'react';
import Style from './../Css/Navbar.module.scss';
import Toggler from "./home/Toggler";
import { Link, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { info } from '../info/Info';
const links = [
    {
        name: 'Home',
        to: '/',
        active: 'home'
    },
    {
        name: 'About',
        to: '/about',
        active: 'about'
    },
    {
        name: info.initials,
        type: 'initials',
        to: '/about',
        active: ''
    },
    {
        name: 'Portfolio',
        to: '/portfolio',
        active: 'portfolio'
    },
    {
        name: 'Blog',
        to: '/blog',
        active: 'blog'
    }
]

export default function Navbar({ darkMode, handleClick })
{
    const location = useLocation()
    const [active, setActive] = useState(location.pathname === '/' ? 'home' : location.pathname.slice(1, location.pathname.length));

    const handleDownload = () =>
    {
        const link = document.createElement('a');
        link.href = process.env.PUBLIC_URL + '/Ali Eren Kayhan CV.pdf';
        link.download = 'Ali Eren Kayhan CV.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Box component={'nav'} width={'100%'}>
            <Box component={'ul'} display={'flex'} justifyContent={'center'} alignItems={'center'}
                gap={{ xs: '1rem', md: '8rem' }}
                textTransform={'lowercase'} fontSize={'1rem'}>
                {links.map((link, index) => (
                    <Box key={index} component={'li'} className={(link.active === active && !link.type) && Style.active}
                        sx={{ borderImageSource: info.gradient }}>
                        {link.type !== 'initials' ? (
                            <Link to={link.to} onClick={() => setActive(link.active)} className={Style.link}>
                                <p style={{ padding: '0.5rem 0' }}>{link.name}</p>
                            </Link>
                        ) : (
                            <button onClick={handleDownload} className={Style.link} style={{ border: 'none', background: 'none', padding: 0, margin: 0 }}>
                                <h1>{link.name}</h1>
                            </button>
                        )}
                    </Box>
                ))}
                <li>
                    <Toggler darkMode={darkMode} handleClick={handleClick} />
                </li>
            </Box>
        </Box>
    )
}
